import { createAction } from '@reduxjs/toolkit';
import { RequestError, Mask, Callback, UpdateMaskParams } from 'types';

export const updateMask = createAction(
  'mask/update-mask',
  (mask: UpdateMaskParams, callback?: Callback<unknown, void>) => ({
    payload: undefined,
    meta: { mask, callback },
  })
);

export const updatedMask = createAction('mask/updated-mask', (data?: Mask, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  updateMask,
  updatedMask,
};
